var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1472_11496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65055 20.9101C7.62055 20.9101 7.58055 20.9301 7.55055 20.9301C5.61055 19.9701 4.03055 18.3801 3.06055 16.4401C3.06055 16.4101 3.08055 16.3701 3.08055 16.3401C4.30055 16.7001 5.56055 16.9701 6.81055 17.1801C7.03055 18.4401 7.29055 19.6901 7.65055 20.9101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9391 16.4501C19.9491 18.4401 18.2991 20.0501 16.2891 21.0201C16.6691 19.7501 16.9891 18.4701 17.1991 17.1801C18.4591 16.9701 19.6991 16.7001 20.9191 16.3401C20.9091 16.3801 20.9391 16.4201 20.9391 16.4501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0191 7.70998C19.7591 7.32998 18.4891 7.01998 17.1991 6.79998C16.9891 5.50998 16.6791 4.22998 16.2891 2.97998C18.3591 3.96998 20.0291 5.63998 21.0191 7.70998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65047 3.09006C7.29047 4.31006 7.03047 5.55006 6.82047 6.81006C5.53047 7.01006 4.25047 7.33006 2.98047 7.71006C3.95047 5.70006 5.56047 4.05006 7.55047 3.06006C7.58047 3.06006 7.62047 3.09006 7.65047 3.09006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4898 6.59C13.1698 6.33 10.8298 6.33 8.50977 6.59C8.75977 5.22 9.07977 3.85 9.52977 2.53C9.54977 2.45 9.53977 2.39 9.54977 2.31C10.3398 2.12 11.1498 2 11.9998 2C12.8398 2 13.6598 2.12 14.4398 2.31C14.4498 2.39 14.4498 2.45 14.4698 2.53C14.9198 3.86 15.2398 5.22 15.4898 6.59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59 15.49C5.21 15.24 3.85 14.92 2.53 14.47C2.45 14.45 2.39 14.46 2.31 14.45C2.12 13.66 2 12.85 2 12C2 11.16 2.12 10.34 2.31 9.56001C2.39 9.55001 2.45 9.55001 2.53 9.53001C3.86 9.09001 5.21 8.76001 6.59 8.51001C6.34 10.83 6.34 13.17 6.59 15.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 12C22.0002 12.85 21.8802 13.66 21.6902 14.45C21.6102 14.46 21.5502 14.45 21.4702 14.47C20.1402 14.91 18.7802 15.24 17.4102 15.49C17.6702 13.17 17.6702 10.83 17.4102 8.51001C18.7802 8.76001 20.1502 9.08001 21.4702 9.53001C21.5502 9.55001 21.6102 9.56001 21.6902 9.56001C21.8802 10.35 22.0002 11.16 22.0002 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4898 17.4099C15.2398 18.7899 14.9198 20.1499 14.4698 21.4699C14.4498 21.5499 14.4498 21.6099 14.4398 21.6899C13.6598 21.8799 12.8398 21.9999 11.9998 21.9999C11.1498 21.9999 10.3398 21.8799 9.54977 21.6899C9.53977 21.6099 9.54977 21.5499 9.52977 21.4699C9.08977 20.1399 8.75977 18.7899 8.50977 17.4099C9.66977 17.5399 10.8298 17.6299 11.9998 17.6299C13.1698 17.6299 14.3398 17.5399 15.4898 17.4099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7633 15.7633C13.2622 16.0789 10.7378 16.0789 8.23667 15.7633C7.92111 13.2622 7.92111 10.7378 8.23667 8.23667C10.7378 7.92111 13.2622 7.92111 15.7633 8.23667C16.0789 10.7378 16.0789 13.2622 15.7633 15.7633Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1472_11496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.a32a7a43eb2aa102d3ba7475bde5b1f5.svg";
export { ForwardRef as ReactComponent };